import React, { useState } from "react";
import BasicApplication from "../../../components/membership/cpasapplication/BasicApplication";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";
import SwalServices from "../../../services/swalServices/SwalServices";
import CPASMemberServices from "../../../services/axiosServices/apiServices/CPASMemberServices";
import { Component } from "react-image-crop";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { checkParameters, encryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";
import {
  CAPSBasicApplicationObject,
  cpdSubmissionDetailsObj,
  EducationDetails,
  OrganisationReference,
  ProfessionalQualificationDetail,
  ProfessionalQualificationDetailIfApplicable,
  ProjectandPaymentInfoObj,
} from "../../../components/AllStateObjects";
import { validate } from "../../../utils/validation/CommonValidator";
import EducationalInformation from "../../../components/membership/cpasapplication/EducationalInformation";
import { CommonSuccessMessages } from "../../../utils/Messages";
import moment from "moment";
import { saveAs } from "file-saver";
import ProjectInfoSummary from "./ProjectInfoSummary";
import EmploymentInformation from "../../../components/membership/cpasapplication/EmploymentInformation";
import CPASMembershipTaskListProcess from "../../../components/membership/cpasapplication/CPASMembershipTaskListProcess";
import SendClarifications from "./SendClarifications";
import CpdSubmission from "./CpdSubmission";
import { getAuditContext } from "../../../utils/audit/AuthenticationLibrary";
export default class ViewCPASApplication extends Component {
  constructor(props) {
    super(props);
    this.swalServices = new SwalServices();
    this.CPASMemberServices = new CPASMemberServices();
    this.scrollRef = React.createRef();
    this.state = {
      assessorInterviewResultsPath: [],
      isApproveappealLoading: false,
      isRejectappealLoading: false,
      isApproveLoading: false,
      isAppealLoading: false,
      isRejectLoading: false,
      setSendClarifications: false,
      clarification: "",
      interviewComment: "",
      interviewComments: "",
      pptFilepath: "",
      statusId: 0,
      secretariatAndPreAssessmentStatusId: 0,
      updatedBy: 0,
      updatedAppId: 0,
      isLoading: false,
      mrMrsList: [],
      countryList: [],
      birthPlaceList: [],
      nationalityList: [],
      applicationTierList: [],
      basicApplicationDetails: CAPSBasicApplicationObject,
      oganisationReference: OrganisationReference,
      validStateBasicApplication: {
        isValid: true,
        error: {},
      },
      isDraftLoader: false,
      isSubmitLoader: false,
      validStateBasicAppPassword: {
        isValid: true,
        error: {},
      },
      cpasMemberid: 0,
      paymentStatus: "",
      openProjectCitedInReportModal: false,
      openProfappModal: false,
      openProModal: false,
      openEduModal: false,
      isDraftLoader: false,
      isSubmitLoader: false,
      detail1: EducationDetails,
      detail2: ProfessionalQualificationDetail,
      detail3: ProfessionalQualificationDetailIfApplicable,
      isUploadAccreditedConstruction: false,
      isUploadProfessionalQualifications: false,
      isUploadProfessionalIfApplicable: false,
      isUploadEducationalQualifications: false,
      educationalInformation: {
        educationalInformation1: [],
        educationalInformation2: [],
        educationalInformation3: [],
      },
      employmentInformation: {
        employmentInformations: [],
      },
      projectInformation: {
        projectCitedInReport: [],
      },
      projectInformationdetail: {
        projectCitedInReportId: 0,
        cpasMemberid: 0,

        projectTitle: "",
        projectValue: "",
        roleInProject: "",
        projectDuration: "",
        projectDateFrom: "",
        projectDateTo: "",
        projectTypeAndScope: "",
        roleDescription: "",
        responsibilitiesDescription: "",
        projectDocumentFilePath: "",

        endorserFirstName: "",
        endorserLastName: "",
        endorserRole: "",
        endorserEmail: "",
        endorsementFilePath: "",
      },
      projectCiteWrittenObj: "",
      projectInfoSummary: "",
      cpdSubmissionDetails: "",
      summaryCheckBoxSection: {
        HasAgreedToDataProtectionPolicy: false,
        HasAgreedToAllTermsandConditions: false,
      },
      projectAndPaymentInfoSummary: ProjectandPaymentInfoObj,
      cpdSubmissionDetailsObj: cpdSubmissionDetailsObj,

      applicationfeeInvoicePath: "",

      isUploadDocumentary: false,
      isEndorsement: false,
      qualificationTypeList: [],
      allInterviewDetailsList: [],
      openEmploymentModal: false,
      employmentInformationdetail: {
        employmentHistoryId: 0,
        cpasMemberid: 0,

        companyName: "",
        positionHeld: "",
        employmentDuration: "",
        employmentFromDate: "",
        employmentToDate: "",

        projectsInvolved: "",
        jobTitle: "",
        contractValues: "",
        employmentFromYear: "",
        employmentToYear: "",
        projectInvolvementpercentage: 0,
        locationOfProject: "",

        isProjectManagementRole: null,
        rolesAndResponsibilities: "",
        isConstruction: true,
        supportingDocumentPath: "",
        interviewComment: "",

        interviewText: "",
      },
    };
  }

  componentDidMount() {
    const audit = getAuditContext();

    let params = new URLSearchParams(window.location.search);
    let cpasId = params.get("");

    // let cookie = getAuthProps();
    // if (cookie != null) {
    //   const adminUserId = cookie.adminUserId;
    //   const adminname = cookie.name;
    //   this.setState({
    //     updatedBy: adminUserId,
    //     updatedAppId: 111,
    //     adminName: adminname,
    //   });
    // }

    if (cpasId && (cpasId = checkParameters(cpasId, "Number"))) {
      if (cpasId > 0) {
        this.setState({ cpasMemberid: cpasId }, () => {
          // NOW state is guaranteed ready
          this.GetCPASMemberDetailByMemberId(cpasId);
        });
      }
    }

    this.GetAllDropDownsForCPASMember();
    this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });

  }



  saveClarificationDetails = () => {
    //  let isValidInput = this.isValidateAllFields1();
    const audit = getAuditContext();

    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_SendClarifications.replace(
          "{0}",
          "Admin"
        ),
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          let request = {
            cpasMemberId: this.state.cpasMemberid,
            clarificationDetails: this.state.clarification,
            updatedBy: audit.adminUserId,
            updatedAppId: audit.appId,
            IsClarificationSecretariat: this.state.isClarificationSecretariat
          };
          this.setState({ isLoading: true });

          this.CPASMemberServices.SendClarificationForSecretariatAndPreAssessment(
            request
          ).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
              const statusId = this.state.isClarificationSecretariat ? 29 : 33;
              this.UpdateSecretariatAndPreAssessmentStatus(statusId);
              this.swalServices.Success("Clarification mail sent successfully");

              this.setState({ setSendClarifications: false });
              this.setState({ clarification: "" });
              this.GetCPASMemberDetailByMemberId(this.state.cpasMemberid);
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
          });
        } else {
          this.setState({ isLoading: false });
          this.setState({ setSendClarifications: false });
        }
      });
  };
  GetCPASMemberFiles = (type, Filepath) => {
    let request = [this.state.cpasMemberid, type, Filepath];
    this.setState({ isLoading: true });
    this.CPASMemberServices.GetCPASMemberFiles(request).then((response) => {
      if (response.data !== null && response.status === 200) {
        let formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
        let filename = "";
        filename = `${type}${formattedDate}`;
        const extension = Filepath.split(".").pop();
        let file = "";
        if (extension == "pdf") {
          file = new Blob([response.data], { type: "application/pdf" });
          URL.createObjectURL(file);
          window.open(URL.createObjectURL(file), "_blank");
          saveAs(file, `${filename}.${extension}`);
        } else {
          file = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          URL.createObjectURL(file);
          const fileNameWithoutExt = Filepath.replace(/\.[^/.]+$/, "");
          saveAs(file, `${fileNameWithoutExt}.${extension}`);

        }
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };

  getEmploymentHistoryById = (id) => {
    const record = this.state.employmentInformation.employmentInformations.find(
      (x) => x.employmentHistoryId === id
    );

    if (!record) return;

    this.setState({
      employmentInformationdetail: {
        ...record,
        isConstruction: record.isConstruction === true,
      },
    });
  };
  submitProjectSummaryInformation = (flag) => {
    //if (this.isValidateAllFields("Basic_Application")) {
    //this.setState({ isLoading: true });
    const audit = getAuditContext();

    let request = this.state.basicApplicationDetails;
    let summaryRequest = this.state.projectAndPaymentInfoSummary;
    request.paymentProofFilePath = summaryRequest.paymentProofFilePath;
    request.PaymentProofComment = summaryRequest.PaymentProofComment;
    request.accreditedConProReportPath = summaryRequest.accreditedConProReportPath;
    request.cpasMemberid = this.state.cpasMemberid;
    request.applicationTierId = this.state.basicApplicationDetails.applicationTierId;
    request.mrMrsId = this.state.basicApplicationDetails.mrMrsId;
    request.saveInto = "ProjectSummary";
    request.createdBy = audit.adminUserId;
    request.createdAppId = audit.appId;

    this.setState({ isSubmitLoader: true });
    this.CPASMemberServices.CPASMemberSignUp(request).then((response) => {
      this.setState({ isSubmitLoader: false });
      if (response.statusCode === 200 && response.responseItem != null) {
        if (
          response.responseItem.responseContent.membershipPaymentInvoicePath ==
          "" &&
          response.responseItem.responseContent.membershipPaymentInvoicePath ==
          null
        ) {
          this.swalServices.Error(response.message);
        } else {
          this.swalServices
            .SuccessWithAction("Updated Succefully.", "OK")
            .then((res) => {
              this.setState({
                cpasMemberid:
                  response.responseItem.responseContent.cpasMemberId,
                isLogin: true,
                applicationfeeInvoicePath:
                  response.responseItem.responseContent
                    .membershipPaymentInvoicePath,
              });

              res = this.state.projectInformation;
              res.cpasMemberid = this.state.cpasMemberid;
              res.statusId = this.state.statusId;
              this.setState({ projectInformation: res });
            });
        }
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isSubmitLoader: false });
      this.geteducationInformationalldetails();
    });
  };
  getProjectCitedInReport = (key) => {
    let list = this.state.projectInformation.projectCitedInReport;
    let setData = list[key];

    let data = {};

    // ===== Project Basic Fields =====

    data.projectCitedInReportId = setData.projectCitedInReportId;
    data.projectTitle = setData.projectTitle;
    data.projectValue = setData.projectValue;
    data.roleInProject = setData.roleInProject;
    data.projectDuration = setData.projectDuration;
    data.projectDateFrom = setData.projectDateFrom;
    data.projectDateTo = setData.projectDateTo;

    // ===== Project Description Fields =====
    data.projectTypeAndScope = setData.projectTypeAndScope;
    data.roleDescription = setData.roleDescription;
    data.responsibilitiesDescription = setData.responsibilitiesDescription;

    // ===== Document Fields =====
    data.projectDocumentFilePath = setData.projectDocumentFilePath;

    // ===== Endorser Details =====
    data.endorserFirstName = setData.endorserFirstName;
    data.endorserLastName = setData.endorserLastName;
    data.endorserRole = setData.endorserRole;
    data.endorserEmail = setData.endorserEmail;
    data.endorsementFilePath = setData.endorsementFilePath;

    // set to state
    this.setState({ projectInformationdetail: data });
  };

  getEmploymentHistory = (key) => {
    let list = this.state.employmentInformation.employmentInformations;
    let setData = list[key];

    let data = {};
    // ===== Common Fields =====
    data.employmentHistoryId = setData.employmentHistoryId;

    data.companyName = setData.companyName;
    data.positionHeld = setData.positionHeld;
    data.employmentDuration = setData.employmentDuration;
    data.employmentFromDate = setData.employmentFromDate;
    data.employmentToDate = setData.employmentToDate;
    data.isConstruction = setData.isConstruction === true;
    // ===== Construction / Project Fields =====
    data.projectsInvolved = setData.projectsInvolved;
    data.jobTitle = setData.jobTitle;
    data.contractValues = setData.contractValues;
    data.employmentFromYear = setData.employmentFromYear;
    data.employmentToYear = setData.employmentToYear;
    data.projectInvolvementpercentage = setData.projectInvolvementpercentage;
    data.locationOfProject = setData.locationOfProject;
    data.isProjectManagementRole = setData.isProjectManagementRole;

    // ===== Description Fields =====
    data.rolesAndResponsibilities = setData.rolesAndResponsibilities;

    // set to state
    this.setState({ employmentInformationdetail: data });
  };

  getEducationalInformation = (key) => {
    let list = this.state.educationalInformation.educationalInformation1;
    let setData = list[key];

    let data = {};
    data.educationalQualificationId = setData.educationalQualificationId;
    data.nameOfInstitution = setData.nameOfInstitution;
    data.titleOfCourse = setData.titleOfCourse;
    data.qualificationTypeId = setData.qualificationTypeId;
    data.yearOfAward = setData.yearOfAward;
    data.durationOfProgramme = setData.durationOfProgramme;
    data.certificateOfEducation = setData.certificateOfEducation;

    this.setState({ detail1: data });
  };
  getProfessionalQualifications = (key) => {
    let list = this.state.educationalInformation.educationalInformation2;
    let setData = list[key];

    let data = {};
    data.professionalQualificationId = setData.professionalQualificationId;
    data.professionalQualification = setData.professionalQualification;
    data.organisation = setData.organisation;
    data.validityDuration = setData.validityDuration;
    data.gradeOfMembership = setData.gradeOfMembership;
    data.certificateFilePath = setData.certificateFilePath;

    this.setState({ detail2: data });
  };
  getProfessionalIfApplicableQualifications = (key) => {
    let list = this.state.educationalInformation.educationalInformation3;
    let setData = list[key];

    let data = {};
    data.professionalQualificationApplicableId =
      setData.professionalQualificationApplicableId;
    data.professionalQualificationName = setData.professionalQualificationName;
    data.organisation = setData.organisation;
    data.validityDuration = setData.validityDuration;
    data.gradeOfMembership = setData.gradeOfMembership;
    data.certificatePath = setData.certificatePath;

    this.setState({ detail3: data });
  };

  submitEducationalInformation = (flag) => {
    const audit = getAuditContext();

    let request = this.state.basicApplicationDetails;
    request.cpasMemberid = this.state.cpasMemberid;
    request.saveInto = "EducationalInformation";
    request.createdBy = audit.adminUserId;
    request.createdAppId = audit.appId;

    const isDraft = flag === "isDraft";
    this.setState({ isSubmitLoader: true });
    this.CPASMemberServices.CPASMemberSignUp(request).then((response) => {
      this.setState({ isSubmitLoader: false });
      if (response.statusCode === 200 && response.responseItem != null) {
        this.swalServices
          .SuccessWithAction("Please proceed to the next section.", "OK")
          .then((res) => {
            this.setState({
              cpasMemberid: response.responseItem.responseContent.keyId,
              isLogin: true,
            });
            res = this.state.educationalInformation;
            res.cpasMemberid = this.state.cpasMemberid;
            res.statusId = this.state.statusId;
            this.setState({ educationalInformation: res });
            this.getCPASEducationInformationList(this.state.cpasMemberid);
          });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isSubmitLoader: false });
      this.geteducationInformationalldetails();
    });
  };

  handleChange = (event, section) => {

    const name = event.target.name;
    const rawValue = event.target.value;
    const value =
      name === "password" || name === "confirmPassword"
        ? rawValue
        : rawValue.toUpperCase();

    if (section == "interviewComment") {
      this.setState({ interviewComment: value })
    }
    else if (section === "PasswordAndConfirmPassword") {
      this.setState((prev) => ({
        basicApplicationDetails: {
          ...prev.basicApplicationDetails,
          [name]: value,
        },
      }));
    } else if (section === "PaymentSummary") {
      this.setState((prev) => ({
        projectAndPaymentInfoSummary: {
          ...prev.projectAndPaymentInfoSummary,
          [name]: value,
        },
      }));
    } else if (section === "CAPS_LOGIN") {
      this.setState((prev) => ({
        cpasLogIn: {
          ...prev.cpasLogIn,
          [name]: value,
        },
      }));
    } else if (section === "BasicApplication") {
      this.setState((prev) => ({
        basicApplicationDetails: {
          ...prev.basicApplicationDetails,
          [name]: value,
        },
      }));
    } else if (section === "Educational_Qualification") {
      this.setState((prev) => ({
        detail1: {
          ...prev.detail1,
          [name]: value,
        },
      }));
    } else if (section === "Professional_Qualification") {
      this.setState((prev) => ({
        detail2: {
          ...prev.detail2,
          [name]: value,
        },
      }));
    } else if (section === "Professional_Qualification_IfApplicable") {
      this.setState((prev) => ({
        detail3: {
          ...prev.detail3,
          [name]: value,
        },
      }));
    } else if (section === "Employment_History") {
      this.setState((prev) => ({
        employmentInformationdetail: {
          ...prev.employmentInformationdetail,
          [name]: value,
        },
      }));
    } else if (section === "Professional_References") {
      this.setState((prev) => ({
        oganisationReference: {
          ...prev.oganisationReference,
          [name]: value,
        },
      }));
    } else if (section === "Project_Cited_In_Report") {
      this.setState((prev) => ({
        projectInformationdetail: {
          ...prev.projectInformationdetail,
          [name]: value,
        },
      }));
    } else if (section === "Project_Cite_Written_Report") {
      this.setState((prev) => ({
        projectCiteWrittenObj: {
          ...prev.projectCiteWrittenObj,
          [name]: value,
        },
      }));
    } else if (section === "Basic_Application_Radio") {
      this.setState((prev) => ({
        basicApplicationDetails: {
          ...prev.basicApplicationDetails,
          [name]: rawValue === "true",
        },
      }));
    } else if (section === "Employment_History_Radio") {
      this.setState((prev) => ({
        employmentInformationdetail: {
          ...prev.employmentInformationdetail,
          [name]: !prev.employmentInformationdetail[name],
        },
      }));
    } else if (section === "Project_Info_Summary_Checkbox1") {
      this.setState((prev) => ({
        projectInfoSummary: {
          ...prev.projectInfoSummary,
          [name]: !prev.projectInfoSummary[name],
        },
      }));
    } else if (section === "Project_Info_Summary_Checkbox2") {
      this.setState((prev) => ({
        projectInfoSummary: {
          ...prev.projectInfoSummary,
          [name]: !prev.projectInfoSummary[name],
        },
      }));
    }
    else if (section === "CpdSubmission") {
      this.setState((prev) => ({
        cpdSubmissionDetailsObj: {
          ...prev.cpdSubmissionDetailsObj,
          [name]: value,
        },
      }));
    }
    else if (section === "Benefit_radio") {
      this.setState((prev) => ({
        cpdSubmissionDetailsObj: {
          ...prev.cpdSubmissionDetailsObj,
          [name]: rawValue === "true",
        },
      }));
    }
  };

  onFileChange = (event, identity) => {
    debugger
    const file = event.target.files[0];
    const maxFileSizeforUpload_Accrediate_Construction_Professional_Report = 14 * 1024 * 1024;
    if (identity === "Upload_Accrediate_Construction_Professional_Report") {
      if (file.size > maxFileSizeforUpload_Accrediate_Construction_Professional_Report) {
        this.swalServices.Error("File size should not be more than 14 MB.");
        return;
      }
    }

    const maxFileSize = 2 * 1024 * 1024; // 2 MB
    if (identity === "Letters_Of_Proffesion" || identity === "Second_Letters_Of_Proffesion") {
      if (file.size > maxFileSize) {
        this.swalServices.Error("File size should not be more than 2 MB.");
        return;
      }
    }

    if (file.size < 5242880|| identity === "Upload_Accrediate_Construction_Professional_Report") {
      if (identity === "Upload_Accrediate_Construction_Professional_Report") {
        debugger;

        if (
          file &&
          (
            file.name.toLowerCase().endsWith(".zip") ||
            file.name.toLowerCase().endsWith(".rar")
          )
        ) {

         

          if (file.size > maxFileSize) {
            this.swalServices.Error("File size should not exceed 14 MB!");
            return;
          }

          let uploadFile = { ...this.state.resFile };
          uploadFile.filename = file.name;
          uploadFile["file"] = file;
          uploadFile.storagePath =
            "CPASMemberData\\AccreditedConstructionProfessionalWrittenReports";

          this.setState({ isUploadAccreditedConstruction: true });

          this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
            if (response != null) {
              if (response.isNotCurrupted == true) {
                let detail = this.state.projectAndPaymentInfoSummary;
                detail.accreditedConProReportPath = response.fileName;

                this.swalServices.Success("File Uploaded");

                this.setState(
                  { projectAndPaymentInfoSummary: detail },
                  () => {
                    // this.validateField("accreditedConProReportPath", "Education_Information")
                  }
                );
              } else {
                this.swalServices.Error("Invalid Document");
              }
            } else {
              this.swalServices.Error(response.message);
            }

            this.setState({ isUploadAccreditedConstruction: false });
          });
        } else {
          this.swalServices.Error("Please upload only ZIP or RAR files!");
        }
      } else if (identity === "Letters_Of_Proffesion") {
        if (
          (file && file.type === "application/pdf") ||
          file.type === "application/pdf" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/msword" || (file.type.startsWith("image/") && file.type !== "image/svg+xml")
        ) {
          let uploadFile = { ...this.state.resFile };
          uploadFile.filename = file.name;
          uploadFile["file"] = file;
          uploadFile.storagePath = "CPASMemberData\\LettersOfProffesion";
          this.setState({ isLettersOfProffesion: true });
          this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
            if (response != null) {
              if (response.isNotCurrupted == true) {
                let detail = this.state.oganisationReference;
                detail.referenceDocumentFilePath = response.fileName;
                this.swalServices.Success("File Uploaded");
                this.setState({ oganisationReference: detail }, () => {
                  //this.validateField("referenceDocumentFilePath", "Employment_Information")
                });
              } else {
                this.swalServices.Error("Invalid Document");
              }
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLettersOfProffesion: false });
          });
        } else {
          this.swalServices.Error("Please upload only PDF, DOC, DOCX , JPG, JPEG, PNG files!");
        }
      } else if (identity === "Second_Letters_Of_Proffesion") {
        if (
          (file && file.type === "application/pdf") ||
          file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/msword" ||
          (file.type.startsWith("image/") && file.type !== "image/svg+xml")
        ) {
          let uploadFile = { ...this.state.resFile };
          uploadFile.filename = file.name;
          uploadFile["file"] = file;
          uploadFile.storagePath = "CPASMemberData\\LettersOfProffesion";

          this.setState({ isSecondLettersOfProffesion: true });

          this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
            if (response != null) {
              if (response.isNotCurrupted == true) {
                let detail = this.state.oganisationReference;

                detail.secondReferenceDocumentFilePath = response.fileName;

                this.swalServices.Success("File Uploaded");

                this.setState(
                  { oganisationReference: detail },
                  () => {
                    // this.validateField(
                    //     "secondReferenceDocumentFilePath",
                    //     "Employment_Information"
                    // );
                  }
                );
              } else {
                this.swalServices.Error("Invalid Document");
              }
            } else {
              this.swalServices.Error(response.message);
            }

            this.setState({ isSecondLettersOfProffesion: false });
          });
        } else {
          this.swalServices.Error(
            "Please upload only PDF, DOC, DOCX, JPG, JPEG, PNG files!"
          );
        }
      }
      else if (identity === "Upload_Payment_Proof") {
        if (
          file &&
          (file.type === "application/pdf" ||
            (file.type.startsWith("image/") && file.type !== "image/svg+xml"))
        ) {
          let uploadFile = {};
          uploadFile.filename = file.name;
          uploadFile["file"] = file;
          uploadFile.storagePath = "PaymentImages";
          this.setState({ isFullFacePhoto: true }, () => {
            this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
              if (response != null) {
                let detail = { ...this.state.projectAndPaymentInfoSummary };
                detail["paymentProofFilePath"] = response.fileName;
                this.setState(
                  { projectAndPaymentInfoSummary: detail },
                  console.log(
                    "payment Proof FilePath :",
                    this.state.projectAndPaymentInfoSummary
                  )
                );
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isFullFacePhoto: false });
            });
          });
        } else {
          this.swalServices.Error(
            "Please upload only image files (JPG, JPEG, PNG) with a maximum size of 5 MB."
          );
        }
      } else if (identity === "Upload_Full_Face_Photo") {
        if (file && file.type.startsWith("image/")) {
          let uploadFile = {};
          uploadFile.filename = file.name;
          uploadFile["file"] = file;
          uploadFile.storagePath = "CPASMemberData";
          this.setState({ isFullFacePhoto: true }, () => {
            this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
              if (response != null) {
                let detail = { ...this.state.basicApplicationDetails };
                detail["photoFilePath"] = response.fileName;
                this.setState(
                  { basicApplicationDetails: detail },
                  console.log(
                    "Full Face Photo path :",
                    this.state.basicApplicationDetails
                  )
                );
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isFullFacePhoto: false });
            });
          });
        } else {
          this.swalServices.Error(
            "Please upload only image files (JPG, JPEG, PNG) with a maximum size of 5 MB."
          );
        }
      } else if (identity === "Education_Qualification_Training") {
        if (
          (file && file.type === "application/pdf") ||
          file.type === "application/pdf" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/msword" || (file.type.startsWith("image/") && file.type !== "image/svg+xml")
        ) {
          let uploadFile = { ...this.state.resFile };
          uploadFile.filename = file.name;
          uploadFile["file"] = file;
          uploadFile.storagePath =
            "CPASMemberData\\EducationQualification_Certificate";
          this.setState({ isUploadEducationalQualifications: true });
          this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
            if (response != null) {
              if (response.isNotCurrupted == true) {
                let detail = this.state.detail1;
                detail.certificateOfEducation = response.fileName;
                this.swalServices.Success("File Uploaded");
                this.setState({ detail1: detail }, () => {
                  //this.validateField("certificateOfEducation", "Education_Information")
                });
              } else {
                this.swalServices.Error("Invalid Document");
              }
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isUploadEducationalQualifications: false });
          });
        } else {
          this.swalServices.Error("Please upload only PDF, DOC, DOCX , JPG, JPEG, PNG files!");
        }
      } else if (identity === "Professional_Qualification_Training") {
        if (
          (file && file.type === "application/pdf") ||
          file.type === "application/pdf" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/msword" || (file.type.startsWith("image/") && file.type !== "image/svg+xml")
        ) {
          let uploadFile = { ...this.state.resFile };
          uploadFile.filename = file.name;
          uploadFile["file"] = file;
          uploadFile.storagePath =
            "CPASMemberData\\ProfessionalQualification_Certificate";
          this.setState({ isUploadProfessionalQualifications: true });
          this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
            if (response != null) {
              if (response.isNotCurrupted == true) {
                let detail = this.state.detail2;
                detail.certificateFilePath = response.fileName;
                this.swalServices.Success("File Uploaded");
                this.setState({ detail2: detail }, () => {
                  //this.validateField("certificateFilePath", "Education_Information")
                });
              } else {
                this.swalServices.Error("Invalid Document");
              }
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isUploadProfessionalQualifications: false });
          });
        } else {
          this.swalServices.Error("Please upload only PDF, DOC, DOCX , JPG, JPEG, PNG files!");
        }
      } else if (identity === "ProfessionalApplicable_Qualification_Training") {
        if (
          (file && file.type === "application/pdf") ||
          file.type === "application/pdf" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/msword" || (file.type.startsWith("image/") && file.type !== "image/svg+xml")
        ) {
          let uploadFile = { ...this.state.resFile };
          uploadFile.filename = file.name;
          uploadFile["file"] = file;
          uploadFile.storagePath =
            "CPASMemberData\\ProfessionalQualificationIfApplicable_Certificate";
          this.setState({ isUploadProfessionalIfApplicable: true });
          this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
            if (response != null) {
              if (response.isNotCurrupted == true) {
                let detail = this.state.detail3;
                detail.certificatePath = response.fileName;
                this.swalServices.Success("File Uploaded");
                this.setState({ detail3: detail }, () => {
                  //this.validateField("certificatePath", "Education_Information")
                });
              } else {
                this.swalServices.Error("Invalid Document");
              }
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isUploadProfessionalIfApplicable: false });
          });
        } else {
          this.swalServices.Error("Please upload only PDF, DOC, DOCX, JPG, JPEG, PNG  files!");
        }
      } else if (identity === "Documentary_Proof_Project") {
        if (
          (file && file.type === "application/pdf") ||
          file.type === "application/pdf" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/msword" || (file.type.startsWith("image/") && file.type !== "image/svg+xml")
        ) {
          let uploadFile = { ...this.state.resFile };
          uploadFile.filename = file.name;
          uploadFile["file"] = file;
          uploadFile.storagePath = "CPASMemberData\\DocumentaryProofProject";
          this.setState({ isUploadDocumentary: true });
          this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
            if (response != null) {
              if (response.isNotCurrupted == true) {
                let detail = this.state.projectInformationdetail;
                detail.projectDocumentFilePath = response.fileName;
                this.swalServices.Success("File Uploaded");
                this.setState({ projectInformationdetail: detail }, () => {
                  //this.validateField("projectDocumentFilePath", "Education_Information")
                });
              } else {
                this.swalServices.Error("Invalid Document");
              }
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isUploadDocumentary: false });
          });
        } else {
          this.swalServices.Error("Please upload only PDF, DOC, DOCX, JPG, JPEG, PNG  files!");
        }
      } else if (identity === "Endorsement_Project") {
        if (
          (file && file.type === "application/pdf") ||
          file.type === "application/pdf" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/msword" || (file.type.startsWith("image/") && file.type !== "image/svg+xml")
        ) {
          let uploadFile = { ...this.state.resFile };
          uploadFile.filename = file.name;
          uploadFile["file"] = file;
          uploadFile.storagePath = "CPASMemberData\\EndorsementProject";
          this.setState({ isEndorsement: true });
          this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
            if (response != null) {
              if (response.isNotCurrupted == true) {
                let detail = this.state.projectInformationdetail;
                detail.endorsementFilePath = response.fileName;
                this.swalServices.Success("File Uploaded");
                this.setState({ projectInformationdetail: detail }, () => { });
              } else {
                this.swalServices.Error("Invalid Document");
              }
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isEndorsement: false });
          });
        } else {
          this.swalServices.Error("Please upload only PDF, DOC, DOCX, JPG, JPEG, PNG  files!");
        }
      }
    } else {
      this.swalServices.Error("File size must be less than 5 MB");
    }
  };
  geteducationInformationalldetails = () => {
    this.getCPASEducationInformationList();
    this.getCPASProfessionalQualificationsList();
    this.getCPASProfessionalQualificationIfApplicable();
  };
  handleChangeClarificationDetails = (data) => {
    if (typeof data === "string") {
      this.setState({
        clarification: data,
      });
    }
  };

  submitEmploymentInformation = (flag) => {
    const audit = getAuditContext();

    let request = this.state.oganisationReference;
    request.cpasMemberid = this.state.cpasMemberid;
    request.statusId = this.state.statusId;
    request.createdBy = audit.adminUserId;
    request.createdAppId = audit.appId;

    request.saveInto = "EmploymentInformation";
    this.setState({ isSubmitLoader: true });
    this.CPASMemberServices.CPASMemberSignUp(request).then((response) => {
      this.setState({ isSubmitLoader: false });
      if (response.statusCode === 200 && response.responseItem != null) {
        this.swalServices
          .SuccessWithAction("Updated Succefully", "OK")
          .then((res) => {
            this.setState({
              cpasMemberid: response.responseItem.responseContent.keyId,
              isLogin: true,
            });
            res = this.state.employmentInformation;
            res.cpasMemberid = this.state.cpasMemberid;
            res.statusId = this.state.statusId;
            this.setState({ employmentInformation: res });
          });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isSubmitLoader: false });
      this.geteducationInformationalldetails();
    });
  };

  submitBasicApplication = (flag) => {
    const audit = getAuditContext();

    let request = this.state.basicApplicationDetails;
    request.cpasMemberid = this.state.cpasMemberid;
    request.saveInto = "BasicApplication";
    request.updatedBy = audit.adminUserId;
    request.createdBy = audit.adminUserId;
    request.createdAppId = audit.appId;

    this.setState({ isSubmitLoader: true });
    this.CPASMemberServices.CPASMemberSignUp(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        this.swalServices
          .SuccessWithAction("Updated Succefully.", "OK")
          .then((res) => {
            this.setState({
              cpasMemberid: response.responseItem.responseContent.keyId,
              isLogin: true,
            });
            res = this.state.basicApplicationDetails;
            res.cpasMemberid = this.state.cpasMemberid;
            this.setState({ basicApplicationDetails: res });
          });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isSubmitLoader: false });
    });
  };

  handleEmploymentRadioChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      employmentInformationdetail: {
        ...prevState.employmentInformationdetail,
        [name]: value === "true",
      },
    }));
  };

  // Handle all multiselect dropdown change method
  // Handle all multiselect dropdown changes immutably
  handleChangeSelectorDropdown = (selected, identity) => {
    this.setState((prevState) => {
      switch (identity) {
        case "Application_Tire":
          return {
            basicApplicationDetails: {
              ...prevState.basicApplicationDetails,
              applicationTierId: selected.value,
            },
          };

        case "Selected_Country":
          return {
            basicApplicationDetails: {
              ...prevState.basicApplicationDetails,
              countryId: selected.value,
            },
          };

        case "Place_Of_Birth":
          return {
            basicApplicationDetails: {
              ...prevState.basicApplicationDetails,
              placeOfBirthId: selected.value,
            },
          };

        case "Selected_Nationality":
          return {
            basicApplicationDetails: {
              ...prevState.basicApplicationDetails,
              nationalityId: selected.value,
            },
          };

        case "Qualification_Type":
          return {
            detail1: {
              ...prevState.detail1,
              qualificationTypeId: selected.value,
              qualificationTypeName: selected.label,
            },
          };

        case "Membership_Grade":
          return {
            detail2: {
              ...prevState.detail2,
              membershipGradeId: selected.value,
              membershipGradeLabel: selected.label,
            },
          };

        case "Percentage_Completed":
          return {
            detail3: {
              ...prevState.detail3,
              percentageCompletedId: selected.value,
              percentageCompletedLabel: selected.label,
            },
          };

        case "MrMrsId":
          return {
            basicApplicationDetails: {
              ...prevState.basicApplicationDetails,
              mrMrsId: selected.value,
            },
          };

        default:
          return null; // No change
      }
    });
  };

  deleteFile = (value, identity) => {
    if (identity === "Upload_Full_Face_Photo") {
      this.setState((prev) => ({
        basicApplicationDetails: {
          ...prev.basicApplicationDetails,
          photoFilePath: "",
        },
      }));
    }
  };

  saveMainImage = (file, keyId, imageIdentity) => {
    file.storagePath = imageIdentity;
    this.CPASMemberServices.storeBase64Image(file).then((response) => {
      if (response != null) {
        if (response.isNotCurrupted == false) {
          this.swalServices.Error("Invalid File");
        } else {
          this.swalServices.Success("Photo Uploaded");
          if (file.storagePath === "CPASMemberData") {
            let detail = this.state.basicApplicationDetails;
            detail.photoFilePath = response.fileName;
            this.setState({ basicApplicationDetails: { ...detail } });
          }
        }
      } else {
        this.swalServices.Error(response.message);
      }
    });
  };
  GetAllDropDownsForCPASMember = () => {
    this.CPASMemberServices.GetAllDropDownsForCPASMember().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let TierList = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "Tier"
        );
        TierList.map(function (item) {
          delete item["dropdownName"];
        });
        TierList = TierList.map((p) => ({ value: p.id, label: p.name }));
        this.setState({ applicationTierList: TierList });

        let country = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "Country"
        );
        country.map(function (item) {
          delete item["dropdownName"];
        });
        country = country.map((p) => ({ value: p.id, label: p.name }));
        this.setState({ countryList: country });

        let placeOfBirthList = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "Country of Birth"
        );
        placeOfBirthList.map(function (item) {
          delete item["dropdownName"];
        });
        placeOfBirthList = placeOfBirthList.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ birthPlaceList: placeOfBirthList });

        let nationalityList = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "Nationality"
        );
        nationalityList.map(function (item) {
          delete item["dropdownName"];
        });
        nationalityList = nationalityList.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ nationalityList: nationalityList });

        let qualificationTypeList =
          response.responseItem.responseContent.filter(
            (drp) => drp.dropdownName === "QualificationType"
          );
        qualificationTypeList.map(function (item) {
          delete item["dropdownName"];
        });
        qualificationTypeList = qualificationTypeList.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ qualificationTypeList: qualificationTypeList });

        let mrMrsList = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "MrMrs"
        );
        mrMrsList.map(function (item) {
          delete item["dropdownName"];
        });
        mrMrsList = mrMrsList.map((p) => ({ value: p.id, label: p.name }));
        this.setState({ mrMrsList: mrMrsList });
      }
    });
  };



  openSection = (section) => {
    // Toggle the section
    this.setState({
      openSection: this.state.openSection === section ? "" : section,
    });

    // Compulsory ID check: Only fetch if we have a member ID
    const memberId = this.state.cpasMemberid;

    if (memberId) {
      // Since all sections call the same function, you can simplify this:
      const sectionsRequiringData = [
        "BasicApplication",
        "EducationalInformation",
        "EmploymentInformation",
        "ProjectInfoSummary",
        "CpdSubmission"
      ];

      if (sectionsRequiringData.includes(section)) {
        this.GetCPASMemberDetailByMemberId(memberId);
      }
    } else {
      console.warn("Cannot fetch section data: cpasMemberid is missing.");
    }
  };

  GetCPASMemberDetailByMemberId = (id) => {
    this.CPASMemberServices.GetCPASMemberDetailByMemberId(id).then(
      (response) => {
        if (
          (response.statusCode === 200 && response.responseItem === null) ||
          response.responseItem != null
        ) {
          if (response.responseItem.responseContent != null) {

            let interviewList = response.responseItem.responseContent.allInterviewDetailsList;
            let res = { ...this.state.basicApplicationDetails };
            let educationalInformation = this.state.educationalInformation;
            let projectInfo = this.state.educationalInformation;
            let emplhistory = this.state.employmentInformation;
            let oganisationReferenceresponse = this.state.oganisationReference;
            let allInterviewDetails = this.state.allInterviewDetailsList;
            let projectPaymentInfoSummaryresponse = this.state.projectAndPaymentInfoSummary;
            let cpdSubmission = this.state.cpdSubmissionDetailsObj;

            projectPaymentInfoSummaryresponse.accreditedConProReportPath = response.responseItem.responseContent.accreditedConProReportPath;
            projectPaymentInfoSummaryresponse.paymentProofFilePath = response.responseItem.responseContent.filePath;
            projectPaymentInfoSummaryresponse.PaymentProofComment = response.responseItem.responseContent.comments;


            res.cpasMemberid = response.responseItem.responseContent.cpasMemberId;
            res.statusId = response.responseItem.responseContent.statusId;
            res.appealComment = response.responseItem.responseContent.appealComment;
            res.statusName = response.responseItem.responseContent.statusName;
            res.applicationTierId = response.responseItem.responseContent.applicationTierId;
            res.mrMrsId = response.responseItem.responseContent.mrMrsId;
            res.firstName = response.responseItem.responseContent.firstName;
            res.lastName = response.responseItem.responseContent.lastName;
            res.interviewComment = response.responseItem.responseContent.interviewComment;
            res.emailAddress = response.responseItem.responseContent.emailAddress;
            res.dateOfBirth = response.responseItem.responseContent.dateOfBirth;
            res.submissionDate = response.responseItem.responseContent.submissionDate;
            res.postalCode = response.responseItem.responseContent.postalCode;
            res.NRIC_Passport_WorkPassNo = response.responseItem.responseContent.nriC_Passport_WorkPassNo;
            res.identificationNo = response.responseItem.responseContent.identificationNo;
            res.isSexMale = response.responseItem.responseContent.isSexMale;
            res.mailingAddressLine1 = response.responseItem.responseContent.mailingAddressLine1;
            res.mailingAddressLine3 = response.responseItem.responseContent.mailingAddressLine3;
            res.mailingAddressLine2 = response.responseItem.responseContent.mailingAddressLine2;
            res.nationalityId = response.responseItem.responseContent.nationalityId;
            res.placeOfBirthId = response.responseItem.responseContent.placeOfBirthId;
            res.contactNumber = response.responseItem.responseContent.contactNumber;
            res.photoFilePath = response.responseItem.responseContent.photoFilePath;
            res.countryId = response.responseItem.responseContent.countryId;
            res.comments = response.responseItem.responseContent.comments;
            res.uploadPaymentProof = response.responseItem.responseContent.uploadPaymentProof;
            res.accreditedConProReportPath =
              response.responseItem.responseContent.accreditedConProReportPath;
            res.paymentStatus = response.responseItem.responseContent.paymentStatus;
            res.paymentStatus = response.responseItem.responseContent.paymentStatus;

            educationalInformation.educationalInformation1 = response.responseItem.responseContent.cpasEducationInformationList;
            educationalInformation.educationalInformation2 = response.responseItem.responseContent.cpasProfessionalQualificationsList;
            educationalInformation.educationalInformation3 = response.responseItem.responseContent.cpasProfessionalQualificationIfApplicable;

            projectInfo.projectCitedInReport = response.responseItem.responseContent.cpasProjectCitedInReport;

            emplhistory.employmentInformations = response.responseItem.responseContent.cpasEmploymentHistory;

            oganisationReferenceresponse.cpasMemberid = response.responseItem.responseContent.cpasMemberId;
            oganisationReferenceresponse.referenceFirstName = response.responseItem.responseContent.referenceFirstName;
            oganisationReferenceresponse.referenceLastName = response.responseItem.responseContent.referenceLastName;
            oganisationReferenceresponse.referenceContactNumber = response.responseItem.responseContent.referenceContactNumber;
            oganisationReferenceresponse.periodKnownInMonths = response.responseItem.responseContent.periodKnownInMonths;
            oganisationReferenceresponse.referenceOrganisation = response.responseItem.responseContent.referenceOrganisation;
            oganisationReferenceresponse.referenceOrganisationAddress = response.responseItem.responseContent.referenceOrganisationAddress;
            oganisationReferenceresponse.referenceRelationship = response.responseItem.responseContent.referenceRelationship;
            oganisationReferenceresponse.referenceEmailAddress = response.responseItem.responseContent.referenceEmailAddress;
            oganisationReferenceresponse.referenceDocumentFilePath = response.responseItem.responseContent.referenceDocumentFilePath;

            oganisationReferenceresponse.secondReferenceFirstName = response.responseItem.responseContent.secondReferenceFirstName;
            oganisationReferenceresponse.secondReferenceLastName = response.responseItem.responseContent.secondReferenceLastName;
            oganisationReferenceresponse.secondReferenceContactNumber = response.responseItem.responseContent.secondReferenceContactNumber;
            oganisationReferenceresponse.secondPeriodKnownInMonths = response.responseItem.responseContent.secondPeriodKnownInMonths;
            oganisationReferenceresponse.secondReferenceOrganisation = response.responseItem.responseContent.secondReferenceOrganisation;
            oganisationReferenceresponse.secondReferenceOrganisationAddress = response.responseItem.responseContent.secondReferenceOrganisationAddress;
            oganisationReferenceresponse.secondReferenceRelationship = response.responseItem.responseContent.secondReferenceRelationship;
            oganisationReferenceresponse.secondReferenceEmailAddress = response.responseItem.responseContent.secondReferenceEmailAddress;
            oganisationReferenceresponse.secondReferenceDocumentFilePath = response.responseItem.responseContent.secondReferenceDocumentFilePath;
            //CPD Details
            const content = response.responseItem.responseContent;
            const cpdSubmissionDetails = content.cpdSubmissionDetails || [];
            cpdSubmission.isLapseBenefitUsed = response.responseItem.responseContent.isLapseBenefitUsed;
            cpdSubmission.totalApprovedCPD = response.responseItem.responseContent.totalApprovedCPD;
            cpdSubmission.availableCarryForwardPoints =
              cpdSubmissionDetails?.[0]?.availableCarryForwardPoints ?? 0;

            cpdSubmission.curruntTotalApprovedCPD =
              cpdSubmissionDetails?.[0]?.curruntTotalApprovedCPD ?? 0;

            cpdSubmission.requiredPointsForNextRenewal =
              cpdSubmissionDetails?.[0]?.requiredPointsForNextRenewal ?? 0;

            cpdSubmission.requiredPointsForCurruntRenewal =
              cpdSubmissionDetails?.[0]?.requiredPointsForCurruntRenewal ?? 0;

            allInterviewDetails = response.responseItem.responseContent.allInterviewDetailsList;




            const employmentList = content.cpasEmploymentHistory || [];
            const firstEmployment = employmentList[0] || null;
            const assessorInterviewResultsPath = interviewList.map(item => ({
              path: item.assessorInterviewSheetPath
            }));

            this.setState((prev) => ({
              basicApplicationDetails: {
                ...prev.basicApplicationDetails,
                firstName: content.firstName,
                lastName: content.lastName,
                mailingAddressLine1: content.mailingAddressLine1,
                mailingAddressLine2: content.mailingAddressLine2,
                mailingAddressLine3: content.mailingAddressLine3,
                emailAddress: content.emailAddress,
                nationalityId: content.nationalityId,
                placeOfBirthId: content.placeOfBirthId,
                contactNumber: content.contactNumber,
                photoFilePath: content.photoFilePath,
                countryId: content.countryId,
                comments: content.comments,
                uploadPaymentProof: content.uploadPaymentProof,
                postalCode: content.postalCode,
                applicationTierId: content.applicationTierId,
                dateOfBirth: content.dateOfBirth,
                submissionDate: content.submissionDate,
                NRIC_Passport_WorkPassNo: content.nriC_Passport_WorkPassNo,
                mrMrsId: content.mrMrsId,
                statusId: content.statusId,
                secretariatAndPreAssessmentStatusId: content.statusId,
                statusName: content.statusName,
                paymentStatus: content.paymentStatus,
                appealComment: content.appealComment,
                accreditedConProReportPath: content.accreditedConProReportPath,
                paymentStatusForAppeal: content.paymentStatusForAppeal,
                totalApprovedCPD: content.totalApprovedCPD,
                isLapseBenefitUsed: content.isLapseBenefitUsed,
                isSexMale: content.isSexMale
              },
              assessorInterviewResultsPath: assessorInterviewResultsPath,
              allInterviewDetailsList: allInterviewDetails,
              statusId: content.statusId,
              interviewComment: content.interviewComment,
              educationalInformation: {
                ...prev.educationalInformation,
                educationalInformation1:
                  content.cpasEducationInformationList || [],
                educationalInformation2:
                  content.cpasProfessionalQualificationsList || [],
                educationalInformation3:
                  content.cpasProfessionalQualificationIfApplicable || [],
              },

              projectInformation: {
                ...prev.projectInformation,
                projectCitedInReport: content.cpasProjectCitedInReport || [],
              },

              employmentInformation: {
                ...prev.employmentInformation,
                employmentInformations: employmentList,
              },
              pptFilepath: content.pptFilePath,

              employmentInformationdetail: firstEmployment
                ? {
                  ...prev.employmentInformationdetail,
                  ...firstEmployment,
                  isConstruction: Boolean(firstEmployment.isConstruction),
                }
                : prev.employmentInformationdetail,

              cpasMemberid: content.cpasMemberId,

              cpdSubmissionDetails: cpdSubmissionDetails,
              cpdSubmissionDetailsObj: cpdSubmission
            }));
          }
        } else {
          this.swalServices.Error(response.message);
        }
        // this.setState({ isLoading: false });
      }
    );
    // }
  };

  deleteCpasEducationalInformation = (value) => {

    const audit = getAuditContext();

    let request = {
      id: value,
      deletedBy: audit.adminUserId,
      appId: audit.appId
    };
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace("{0}", "record"),
        CommonSuccessMessages.Confirm_Delete.replace("{0}", "record"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.CPASMemberServices.deleteCpasEducationalInformation(
            request
          ).then((response) => {
            if (response.statusCode === 200) {
              this.swalServices.Success("Deleted");
              this.getCPASEducationInformationList();
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
          });
        }
      });
  };
  deleteCpasProfessionalQualifications = (value) => {
    const audit = getAuditContext();

    let request = {
      id: value,
      deletedBy: audit.adminUserId,
      appId: audit.appId
    };
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace("{0}", "record"),
        CommonSuccessMessages.Confirm_Delete.replace("{0}", "record"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.CPASMemberServices.deleteCpasProfessionalQualifications(
            request
          ).then((response) => {
            if (response.statusCode === 200) {
              this.swalServices.Success("Deleted");
              this.getCPASProfessionalQualificationsList();
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
          });
        }
      });
  };

  deleteCpasProfessionalIfApplicableQualifications = (value) => {
    const audit = getAuditContext();

    let request = {
      id: value,
      deletedBy: audit.adminUserId,
      appId: audit.appId
    };
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace("{0}", "record"),
        CommonSuccessMessages.Confirm_Delete.replace("{0}", "record"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.CPASMemberServices.deleteCpasProfessionalIfApplicableQualifications(
            request
          ).then((response) => {
            if (response.statusCode === 200) {
              this.swalServices.Success("Deleted");
              this.getCPASProfessionalQualificationIfApplicable();
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
          });
        }
      });
  };
  AddEditCPASEducationalQualifications = (request) => {
    const audit = getAuditContext();

    request.cpasMemberid = this.state.cpasMemberid;
    request.updatedBy = audit.adminUserId;
    request.updatedAppId = audit.appId;

    this.CPASMemberServices.AddEditCPASEducationalQualifications(request).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.getCPASEducationInformationList();
          this.swalServices.Success(
            "Educational Qualifications Added Successfully."
          );
        } else {
          this.swalServices.Error(response.message);
        }
      }
    );
  };

  AddEditCPASProfessionalQualifications = (request) => {
    const audit = getAuditContext();

    request.cpasMemberid = this.state.cpasMemberid;
    request.updatedBy = audit.adminUserId;
    request.updatedAppId = audit.appId;

    this.CPASMemberServices.AddEditCPASProfessionalQualifications(request).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.getCPASProfessionalQualificationsList();
          this.swalServices.Success(
            "Professional Qualifications Added Successfully."
          );
        } else {
          this.swalServices.Error(response.message);
        }
      }
    );
  };

  AddEditCPASProfessionalQualificationIfApplicable = (request) => {
    const audit = getAuditContext();

    request.cpasMemberid = this.state.cpasMemberid;
    request.updatedBy = audit.adminUserId;
    request.updatedAppId = audit.appId;

    this.CPASMemberServices.AddEditCPASProfessionalQualificationIfApplicable(
      request
    ).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        this.getCPASProfessionalQualificationIfApplicable();
        this.swalServices.Success(
          "Professional Qualifications Added Successfully."
        );
      } else {
        this.swalServices.Error(response.message);
      }
    });
  };

  AddEditCPASEmploymentHistory = (request) => {
    const audit = getAuditContext();

    request.cpasMemberid = this.state.cpasMemberid;
    request.updatedBy = audit.adminUserId;
    request.updatedAppId = audit.appId;

    this.CPASMemberServices.AddEditCPASEmploymentHistory(request).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.getCPASEmploymentHistory();
          this.swalServices.Success("Employment History Added Successfully.");
        } else {
          this.swalServices.Error(response.message);
        }
      }
    );
  };
  getCPASEmploymentHistory = () => {
    const { cpasMemberid } = this.state;

    if (cpasMemberid > 0) {
      this.CPASMemberServices.getCPASEmploymentHistory(cpasMemberid).then(
        (response) => {
          if (response.statusCode === 200 && response.responseItem) {
            const list = response.responseItem.responseContent;

            this.setState((prev) => ({
              employmentInformation: {
                ...prev.employmentInformation,
                employmentInformations: list,
              },
              employmentInformationdetail: {
                ...prev.employmentInformationdetail,
                isConstruction: list.length > 0 ? list[0].isConstruction : true,
              },
            }));
          }
        }
      );
    }
  };

  getCPASProjectCitedInReport = () => {
    if (this.state.cpasMemberid > 0) {
      this.CPASMemberServices.getCPASProjectCitedInReport(
        this.state.cpasMemberid
      ).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {

          this.setState((prev) => ({
            projectInformation: {
              ...prev.projectInformation,
              projectCitedInReport: response.responseItem.responseContent,
            },
          }));
        } else {
          this.swalServices.Error(response.message);
        }
      });
    }
  };
  getCPASEducationInformationList = () => {
    if (this.state.cpasMemberid > 0) {
      this.CPASMemberServices.getCPASEducationInformationList(
        this.state.cpasMemberid
      ).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.setState((prev) => ({
            educationalInformation: {
              ...prev.educationalInformation,
              educationalInformation1: response.responseItem.responseContent,
            },
          }));
        } else {
          this.swalServices.Error(response.message);
        }
      });
    }
  };
  getCPASProfessionalQualificationsList = () => {
    if (this.state.cpasMemberid > 0) {
      this.CPASMemberServices.getCPASProfessionalQualificationsList(
        this.state.cpasMemberid
      ).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.setState((prev) => ({
            educationalInformation: {
              ...prev.educationalInformation,
              educationalInformation2: response.responseItem.responseContent,
            },
          }));
        } else {
          this.swalServices.Error(response.message);
        }
      });
    }
  };
  getCPASProfessionalQualificationIfApplicable = () => {
    if (this.state.cpasMemberid > 0) {
      this.CPASMemberServices.getCPASProfessionalQualificationIfApplicable(
        this.state.cpasMemberid
      ).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.setState((prev) => ({
            educationalInformation: {
              ...prev.educationalInformation,
              educationalInformation3: response.responseItem.responseContent,
            },
          }));
        } else {
          this.swalServices.Error(response.message);
        }
      });
    }
  };
  setOpenEduModal = (flag) => {
    this.setState({ openEduModal: flag });
  };
  setOpenProModal = (flag) => {
    this.setState({ openProModal: flag });
  };
  setOpenProfappModal = (flag) => {
    this.setState({ openProfappModal: flag });
  };
  setOpenEmploymentModal = (flag) => {
    this.setState({ openEmploymentModal: flag });
  };
  setOpenProjectCitedInReportModal = (flag) => {
    this.setState({ openProjectCitedInReportModal: flag });
  };
  AddEditCPASProjectCitedInReport = (request) => {
    const audit = getAuditContext();

    request.updatedBy = audit.adminUserId;
    request.updatedAppId = audit.appId;

    this.CPASMemberServices.AddEditCPASProjectCitedInReport(request).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          // this.setState({ projectInformationdetail: { ...this.state.projectInformationdetail, projectCitedInReportId: response.responseItem.projectCitedInReportId } });
          this.getCPASProjectCitedInReport();
          this.swalServices.Success(
            "Project Cited In Report Added Successfully."
          );
        } else {
          this.swalServices.Error(response.message);
        }
      }
    );
  };
  deleteCpasProjectCitedInReport = (value) => {
    const audit = getAuditContext();

    let request = {
      id: value,
      deletedBy: audit.adminUserId,
      appId: audit.appId
    };

    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace("{0}", "record"),
        CommonSuccessMessages.Confirm_Delete.replace("{0}", "record"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.CPASMemberServices.deleteCpasProjectCitedInReport(request).then(
            (response) => {
              if (response.statusCode === 200) {
                this.swalServices.Success("Deleted");
                this.getCPASProjectCitedInReport();
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isLoading: false });
            }
          );
        }
      });
  };

  resetHandler = (Section) => {
    if (Section === "EducationalQualification") {
      let resetEdu = { ...this.state.detail1 };
      resetEdu.nameOfInstitution = "";
      resetEdu.titleOfCourse = "";
      resetEdu.qualificationTypeId = 0;
      resetEdu.yearOfAward = "";
      resetEdu.durationOfProgramme = "";
      resetEdu.certificateOfEducation = "";
      this.setState({ detail1: resetEdu });
    } else if (Section === "ProfessionalQualification") {
      let resetPro = { ...this.state.detail2 };
      resetPro.professionalQualification = "";
      resetPro.organisation = "";
      resetPro.validityDuration = "";
      resetPro.gradeOfMembership = "";
      resetPro.certificateFilePath = "";
      this.setState({ detail2: resetPro });
    } else if (Section === "ProfessionalQualificationApplicable") {
      let resetProApp = { ...this.state.detail3 };
      resetProApp.professionalQualificationName = "";
      resetProApp.organisation = "";
      resetProApp.validityDuration = "";
      resetProApp.gradeOfMembership = "";
      resetProApp.certificatePath = "";
      this.setState({ detail3: resetProApp });
    } else if (Section === "EmploymentHistory") {
      let resetEmployment = { ...this.state.employmentInformationdetail };

      resetEmployment.employmentHistoryId = 0;
      resetEmployment.cpasMemberid = 0;

      resetEmployment.companyName = "";
      resetEmployment.positionHeld = "";
      resetEmployment.employmentDuration = "";
      resetEmployment.employmentFromDate = "";
      resetEmployment.employmentToDate = "";

      resetEmployment.projectsInvolved = "";
      resetEmployment.jobTitle = "";
      resetEmployment.contractValues = "";
      resetEmployment.employmentFromYear = "";
      resetEmployment.employmentToYear = "";
      resetEmployment.projectInvolvementpercentage = 0;
      resetEmployment.locationOfProject = "";

      resetEmployment.isProjectManagementRole = null;
      resetEmployment.rolesAndResponsibilities = "";
      //resetEmployment.isConstruction = true;

      resetEmployment.supportingDocumentPath = "";

      this.setState({ employmentInformationdetail: resetEmployment });
    } else if (Section === "ProjectCitedInReport") {
      let resetProject = { ...this.state.projectInformationdetail };
      resetProject.projectCitedInReportId = 0;
      resetProject.cpasMemberid = 0;
      resetProject.projectTitle = "";
      resetProject.projectValue = "";
      resetProject.roleInProject = "";
      resetProject.projectDuration = "";
      resetProject.projectDateFrom = "";
      resetProject.projectDateTo = "";
      resetProject.projectTypeAndScope = "";
      resetProject.roleDescription = "";
      resetProject.responsibilitiesDescription = "";
      resetProject.projectDocumentFilePath = "";
      resetProject.endorserFirstName = "";
      resetProject.endorserLastName = "";
      resetProject.endorserRole = "";
      resetProject.endorserEmail = "";
      resetProject.endorsementFilePath = "";
      this.setState({ projectInformationdetail: resetProject });
    }
  };
  handleAddRemoveDataList = (action, identity, key) => {
    if (identity === "EducationalQualification") {
      let eduDet1 = { ...this.state.detail1 };
      let eduInfo1 = this.state.educationalInformation;
      if (action === "HandleAdd") {
        this.AddEditCPASEducationalQualifications(eduDet1);
        this.resetHandler("EducationalQualification");
        this.setOpenEduModal(false);
      } else if (action === "HandleRemove") {
        eduInfo1.educationQualoification.splice(key, 1);
      }
      this.setState({ educationalInformation: eduInfo1 });
    } else if (identity === "ProfessionalQualification") {
      let eduDet2 = { ...this.state.detail2 };
      let eduInfo2 = this.state.educationalInformation;
      if (action === "HandleAdd") {
        this.AddEditCPASProfessionalQualifications(eduDet2);
        this.resetHandler("ProfessionalQualification");
        this.setOpenProModal(false);
      } else if (action === "HandleRemove") {
        eduInfo2.educationalInformation2.splice(key, 1);
      }
      this.setState({ educationalInformation: eduInfo2 });
    } else if (identity === "ProfessionalQualificationApplicable") {
      let eduDet3 = { ...this.state.detail3 };
      let eduInfo3 = this.state.educationalInformation;
      if (action === "HandleAdd") {
        this.AddEditCPASProfessionalQualificationIfApplicable(eduDet3);
        this.resetHandler("ProfessionalQualificationApplicable");
        this.setOpenProfappModal(false);
      } else if (action === "HandleRemove") {
        eduInfo3.educationalInformation3.splice(key, 1);
      }
      this.setState({ educationalInformation: eduInfo3 });
    } else if (identity === "EmploymentHistory") {
      let eduDet4 = { ...this.state.employmentInformationdetail };
      let eduInfo4 = this.state.employmentInformation;
      if (action === "HandleAdd") {
        this.AddEditCPASEmploymentHistory(eduDet4);
        this.resetHandler("EmploymentHistory");
        this.setOpenEmploymentModal(false);
      } else if (action === "HandleRemove") {
        eduInfo4.employmentInformations.splice(key, 1);
      }
      this.setState({ educationalInformation: eduInfo4 });
    } else if (identity === "ProjectCitedInReport") {
      let projectDet = { ...this.state.projectInformationdetail };
      projectDet.cpasMemberid = this.state.cpasMemberid;
      let projectInfo = this.state.educationalInformation;

      if (action === "HandleAdd") {
        this.AddEditCPASProjectCitedInReport(projectDet);
        this.resetHandler("ProjectCitedInReport");
        this.setOpenProjectCitedInReportModal(false);
      } else if (action === "HandleRemove") {
        //projectInfo.splice(key, 1);
        projectInfo.projectCitedInReport.splice(key, 1);
      }

      this.setState({ educationalInformation: projectInfo });
    }
  };
  handleEmploymentConstructionChange = (value) => {

    this.setState((prev) => ({
      employmentInformationdetail: {
        ...prev.employmentInformationdetail,
        isConstruction: value,
      },
    }));
  };
  setSendClarificationsFlag = (isSecretariat) => {
    this.setState({
      isClarificationSecretariat: isSecretariat,
      setSendClarifications: true   // ?? THIS OPENS THE MODAL
    });
  };

  UpdateSecretariatAndPreAssessmentStatus = (statusId) => {
    const audit = getAuditContext();

    let req = {};
    req.cpasMemberId = this.state.cpasMemberid;
    req.statusId = statusId;
    req.updatedBy = audit.adminUserId;
    req.updatedAppId = audit.appId;
    this.CPASMemberServices.UpdateSecretariatAndPreAssessmentStatus(req).then(
      (response) => {
        if (response.statusCode === 200) {
          this.setState({ secretariatAndPreAssessmentStatusId: statusId, statusId: statusId });
          this.GetCPASMemberDetailByMemberId(this.state.cpasMemberid)
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      }
    );
  };


  AcceptAndApproveCpasMember = (isAppeal) => {
    const audit = getAuditContext();

    let validText = "";
    // Skip validation if statusId is 6
    if (this.state.statusId !== 40 && !this.state.interviewComment) {
      validText = "Please fill the comments.";
      this.setState({ interviewText: validText });
      return;
    } else {
      this.setState({ interviewText: "" });
    }

    this.swalServices
      .Confirm(
        "Are you sure you want to approve this application?",
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {

          // 🔹 Loader start
          this.setState({
            [isAppeal ? "isApproveLoading" : "isAppealLoading"]: true
          });

          let req = {};
          req.cpasMemberId = this.state.cpasMemberid;
          req.approveInterviewComment = this.state.interviewComment;
          req.updatedBy = audit.adminUserId;
          req.updatedAppId = audit.appId;

          if (req.cpasMemberId > 0) {
            this.CPASMemberServices.AcceptAndApproveCpasMember(req).then(
              (response) => {
                if (response.statusCode === 200) {
                  this.swalServices.Success("Approved successfully");
                  this.GetCPASMemberDetailByMemberId(this.state.cpasMemberid);
                } else {
                  this.swalServices.Error(response.message);
                }

                // 🔹 Loader stop
                this.setState({
                  [isAppeal ? "isApproveLoading" : "isAppealLoading"]: false
                });
              }
            );
          }
        }
      });
  };

  RejectCpasMember = () => {
    const audit = getAuditContext();

    let validText = "";
    if (!this.state.interviewComment) {
      validText = "Please fill the comments."
      this.setState({ interviewText: validText });
    } else {
      validText = "";
      this.setState({ interviewText: validText });
      this.swalServices
        .Confirm(
          "Are you sure you want to reject?",
          "",
          CommonSuccessMessages.Yes_Text,
          CommonSuccessMessages.No_Text
        )
        .then((response) => {
          if (response) {
            this.setState({ isRejectLoading: true });
            let req = {};
            req.cpasMemberId = this.state.cpasMemberid;
            req.rejectInterviewComment = this.state.interviewComment;
            req.updatedBy = audit.adminUserId;
            req.updatedAppId = audit.appId;

            if (req.cpasMemberId > 0) {
              this.CPASMemberServices.RejectCpasMember(req).then(
                (response) => {
                  if (response.statusCode === 200) {
                    this.swalServices.Success("Reject CpasMember rejected successfully");
                    this.GetCPASMemberDetailByMemberId(this.state.cpasMemberid);
                  } else {
                    this.swalServices.Error(response.message);
                  }
                  this.setState({ isRejectLoading: false });
                }
              );
            }
          }
        });
    }
  };

  RejectAppealCpasMember = () => {

    this.swalServices
      .Confirm(
        "Are you sure you want to reject?",
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.setState({ isRejectappealLoading: true });
          this.CPASMemberServices.RejectAppealCpasMember(this.state.cpasMemberid).then(
            (response) => {
              if (response.statusCode === 200) {
                this.swalServices.Success("CPAS Application has been rejected");
                this.GetCPASMemberDetailByMemberId(this.state.cpasMemberid);
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isRejectappealLoading: false });
            }
          );
        }
      });
  };
  openScoringSheet = () => {
    let req = {};
    let data = this.state.basicApplicationDetails;
    req.cpasMemberId = this.state.cpasMemberid;
    req.firstName = data.firstName;
    req.lastName = data.lastName;
    req.emailAddress = data.emailAddress;
    req.statusId = 34

    this.UpdateSecretariatAndPreAssessmentStatus(31)

    let memberId = this.state.cpasMemberid;
    if (memberId && memberId > 0) {
      this.setState({
        route:
          "/PreAssessorCpasScoringSheet/cpasMemberId?=" + encryptAES(memberId),
      });
    }
    this.GetCPASMemberDetailByMemberId(this.state.cpasMemberid)

  };

  openScoringSheetResults = () => {


    let memberId = this.state.cpasMemberid;
    if (memberId && memberId > 0) {
      this.setState({
        route:
          "/PreAssessorCpasScoringSheet/cpasMemberId?=" + encryptAES(memberId),
      });
    }
    this.GetCPASMemberDetailByMemberId(this.state.cpasMemberid)

  };

  rejectSecretariatStage = () => {

    this.UpdateSecretariatAndPreAssessmentStatus(32)
  };


  rejectSPreAssessmentStage = () => {
    const audit = getAuditContext();

    this.swalServices
      .Confirm(
        "Are you sure you want to reject this Pre-Assessment stage?",
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.setState({ isLoading: true });
          let req = {};
          let data = this.state.basicApplicationDetails;

          req.cpasMemberId = this.state.cpasMemberid;
          req.firstName = data.firstName;
          req.lastName = data.lastName;
          req.emailAddress = data.emailAddress;
          req.statusId = 35;
          req.updatedBy = audit.adminUserId;
          req.updatedAppId = audit.appId;

          this.CPASMemberServices.SendRejectionMailToSecretariatAndPreAssessment(req).then((response) => {
            if (response.statusCode === 200 && response.responseItem.responseContent.hasError == false) {
              this.swalServices.Success("Pre-Assessment stage rejected successfully");
              this.UpdateSecretariatAndPreAssessmentStatus(35);
              this.GetCPASMemberDetailByMemberId(this.state.cpasMemberid);
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
          });
        }
      });
  };

  rejectSecretariatReview = () => {
    const audit = getAuditContext();

    this.swalServices
      .Confirm(
        "Are you sure you want to reject this Secretariat Review?",
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.setState({ isLoading: true });
          let req = {};
          let data = this.state.basicApplicationDetails;

          req.cpasMemberId = this.state.cpasMemberid;
          req.firstName = data.firstName;
          req.lastName = data.lastName;
          req.emailAddress = data.emailAddress;
          req.statusId = 32;
          req.updatedBy = audit.adminUserId;
          req.updatedAppId = audit.appId;

          this.CPASMemberServices.SendRejectionMailToSecretariatAndPreAssessment(req).then((response) => {
            if (response.statusCode === 200 && response.responseItem.responseContent.hasError == false) {
              this.swalServices.Success("Secretariat Review rejected successfully");
              this.UpdateSecretariatAndPreAssessmentStatus(32);
              this.GetCPASMemberDetailByMemberId(this.state.cpasMemberid);
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
          });
        }
      });
  };

  sendForPreAssessmentSecretariatReview = () => {
    const audit = getAuditContext();

    this.swalServices
      .Confirm(
        "Are you sure you want to send for Pre-Assessment Secretariat Review?",
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.setState({ isLoading: true });


          let req = {};
          let data = this.state.basicApplicationDetails;

          req.cpasMemberId = this.state.cpasMemberid;
          req.firstName = data.firstName;
          req.lastName = data.lastName;
          req.emailAddress = data.emailAddress;
          req.statusId = 31;
          req.updatedBy = audit.adminUserId;
          req.updatedAppId = audit.appId;

          this.CPASMemberServices.SendForPreAssessmentSecretariatReviewMail(req).then((response) => {
            if (response.statusCode === 200 && response.responseItem.responseContent.hasError == false) {

              this.UpdateSecretariatAndPreAssessmentStatus(31);
              this.GetCPASMemberDetailByMemberId(this.state.cpasMemberid);
              this.swalServices.Success("Sent for Pre-Assessment Secretariat Review successfully");
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
          });


        }
      });
  };
  deleteCpasEmploymentHistory = (value) => {
    const audit = getAuditContext()

    let request = {
      id: value,
      deletedBy: audit.adminUserId,
      appId: audit.appId
    }
    this.swalServices.Confirm(CommonSuccessMessages.Confirm_Question.replace("{0}", "record"), CommonSuccessMessages.Confirm_Delete.replace("{0}", "record"),
      CommonSuccessMessages.Yes_Text, CommonSuccessMessages.No_Text).then((response) => {
        if (response) {
          this.CPASMemberServices.deleteCpasEmploymentHistory(request).then((response) => {
            if (response.statusCode === 200) {

              this.swalServices.Success("Deleted");
              this.getCPASEmploymentHistory();
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
          });
        }
      });
  }
  DownloadCPASMultipleZipFiles = (type) => {
    let request = {};
    if (type === "InterviewSheetFile") {
      request = {
        FileList: this.state.assessorInterviewResultsPath,
        Type: type,
      }
    }
    if (request.FileList && request.FileList.length > 0) {
      this.setState({ isLoading: true });
      this.CPASMemberServices.DownloadCPASMultipleZipFiles(request).then((response) => {
        if (response.data !== null && response.status === 200) {
          var blob = new Blob([response.data]);
          saveAs(blob, type + ".zip");
          this.setState({ isCreatingZip: false });
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
    } else {
      this.swalServices.Error("No data found");
    }
  };

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <>
        <div className="main-body-section">
          {/* Basic Application */}
          <div className="bg-white border border-[#c9c9c9] mb-3">
            <div className="tab w-full border-t">
              <input
                className="absolute opacity-0 toggle-main"
                id="OBI"
                type="checkbox"
                name="corporate-d"
                value="BasicApplication"
                checked={this.state.openSection === "BasicApplication"}
                onClick={() => this.openSection("BasicApplication")}
              />

              <label
                className="heading-part px-7 py-4 border-b border-[#c9c9c9] flex items-center justify-between relative w-auto leading-normal cursor-pointer"
                htmlFor="OBI"
              >
                <span className="small-title font-bold theme-color pl-5">
                  Basic Application
                </span>
              </label>
              <div
                className={`committee-info-overflow tab-content overflow-hidden leading-normal px-0}`}
              >
                <BasicApplication
                  mrMrsList={this.state.mrMrsList}
                  countryList={this.state.countryList}
                  birthPlaceList={this.state.birthPlaceList}
                  nationalityList={this.state.nationalityList}
                  applicationTierList={this.state.applicationTierList}
                  basicApplicationDetails={this.state.basicApplicationDetails}
                  applicationTierId={this.state.basicApplicationDetails.applicationTierId}
                  validStateBasicApplication={this.state.validStateBasicApplication || CAPSBasicApplicationObject}
                  CPASBasicInformationValidationRules={this.state.CPASBasicInformationValidationRules}
                  handleChange={this.handleChange}
                  onFileChange={this.onFileChange}
                  submitBasicApplication={this.submitBasicApplication.bind(this)}
                  handleChangeSelectorDropdown={this.handleChangeSelectorDropdown}
                  passwordValidState={this.state.validStateBasicAppPassword}
                  cpasMemberid={this.state.cpasMemberid}
                  saveMainImage={this.saveMainImage.bind(this)}
                  deleteFile={this.deleteFile.bind(this)}
                  isSubmitLoader={this.state.isSubmitLoader}
                  isDraftLoader={this.state.isDraftLoader}
                />
              </div>
            </div>
          </div>

          {/* Education Information */}
          <div className="bg-white border border-[#c9c9c9] mb-3">
            <div className="tab w-full border-t">
              <input
                className="absolute opacity-0 toggle-main"
                id="Edu"
                type="checkbox"
                name="corporate-d"
                value="EducationalInformation"
                checked={this.state.openSection === "EducationalInformation"}
                onClick={() => this.openSection("EducationalInformation")}
              />
              <label
                className="heading-part px-7 py-4 border-b border-[#c9c9c9] flex items-center justify-between relative w-auto leading-normal cursor-pointer"
                htmlFor="Edu"
              >
                <span className="small-title font-bold theme-color pl-5">
                  Education Information
                </span>
              </label>
              <div className="committee-info-overflow tab-content overflow-hidden leading-normal px-0">
                <div className="2xl:px-10 2xl:py-10 2xl:pt-4 lg:px-7 lg:py-7 lg:pt-4">
                  <EducationalInformation
                    openProfappModal={this.state.openProfappModal}
                    applicationTierId={this.state.basicApplicationDetails.applicationTierId}
                    openProModal={this.state.openProModal}
                    openEduModal={this.state.openEduModal}
                    setOpenEduModal={this.setOpenEduModal.bind(this)}
                    setOpenProModal={this.setOpenProModal.bind(this)}
                    setOpenProfappModal={this.setOpenProfappModal.bind(this)}
                    getEducationalInformation={this.getEducationalInformation.bind(this)}
                    getProfessionalQualifications={this.getProfessionalQualifications.bind(this)}
                    getProfessionalIfApplicableQualifications={this.getProfessionalIfApplicableQualifications.bind(this)}
                    deleteCpasProfessionalIfApplicableQualifications={this.deleteCpasProfessionalIfApplicableQualifications.bind(this)}
                    deleteCpasProfessionalQualifications={this.deleteCpasProfessionalQualifications.bind(this)}
                    deleteCpasEducationalInformation={this.deleteCpasEducationalInformation.bind(this)}
                    qualificationTypeList={this.state.qualificationTypeList}
                    mebershipGradeList={this.state.mebershipGradeList}
                    educationalInformation={this.state.educationalInformation}
                    isUploadEducationalQualifications={this.state.isUploadEducationalQualifications}
                    isUploadProfessionalQualifications={this.state.isUploadProfessionalQualifications}
                    isUploadProfessionalIfApplicable={this.state.isUploadProfessionalIfApplicable}
                    detail1={this.state.detail1}
                    detail2={this.state.detail2}
                    detail3={this.state.detail3}
                    handleChange={this.handleChange}
                    onFileChange={this.onFileChange}
                    handleAddRemoveDataList={this.handleAddRemoveDataList.bind(this)}
                    handleChangeSelectorDropdown={this.handleChangeSelectorDropdown}
                    submitEducationalInformation={this.submitEducationalInformation.bind(this)}
                    cpasMemberid={this.state.cpasMemberid}
                    GetCPASMemberFiles={this.GetCPASMemberFiles.bind(this)}
                    isSubmitLoader={this.state.isSubmitLoader}
                    isDraftLoader={this.state.isDraftLoader}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Employment Information */}
          <div className="bg-white border border-[#c9c9c9] mb-3">
            <div className="tab w-full border-t">
              <input
                className="absolute opacity-0 toggle-main"
                id="EI"
                type="checkbox"
                name="corporate-d"
                value="EmploymentInformation"
                checked={this.state.openSection === "EmploymentInformation"}
                onClick={() => this.openSection("EmploymentInformation")}
              />
              <label
                className="heading-part px-7 py-4 border-b border-[#c9c9c9] flex items-center justify-between relative w-auto leading-normal cursor-pointer"
                htmlFor="EI"
              >
                <span className="small-title font-bold theme-color pl-5">
                  Employment Information
                </span>
              </label>
              <div className="committee-info-overflow tab-content overflow-hidden leading-normal px-0">
                <div className="2xl:px-10 2xl:py-10 2xl:pt-4 lg:px-7 lg:py-7 lg:pt-4">
                  <EmploymentInformation
                    setOpenEmploymentModal={this.setOpenEmploymentModal.bind(
                      this
                    )}
                    openEmploymentModal={this.state.openEmploymentModal}
                    deleteCpasEmploymentHistory={this.deleteCpasEmploymentHistory.bind(this)}
                    applicationTierId={
                      this.state.basicApplicationDetails.applicationTierId
                    }
                    getEmploymentHistory={this.getEmploymentHistory.bind(this)}
                    handleEmploymentConstructionChange={
                      this.handleEmploymentConstructionChange
                    }
                    employmentInformationdetail={
                      this.state.employmentInformationdetail
                    }
                    isUploadAccreditedConstruction={
                      this.state.isUploadAccreditedConstruction
                    }
                    countryList={this.state.countryList}
                    employmentInformation={this.state.employmentInformation}
                    detail3={this.state.detail3}
                    CAPSEmployementInformationValidationRules={
                      this.state.CAPSEmployementInformationValidationRules
                    }
                    CAPSEmployementInformationFirstReferenceValidationRules={
                      this.state
                        .CAPSEmployementInformationFirstReferenceValidationRules
                    }
                    CAPSEmployementInformationSecondReferenceValidationRules={
                      this.state
                        .CAPSEmployementInformationSecondReferenceValidationRules
                    }
                    // validStateEmployementInformation={this.state.validStateEmployementInformation}
                    // validStateFirstReference={this.state.validStateFirstReference}
                    // validStateSecondReference={this.state.validStateSecondReference}
                    handleChange={this.handleChange}
                    onFileChange={this.onFileChange}
                    handleAddRemoveDataList={this.handleAddRemoveDataList}
                    handleChangeSelectorDropdown={
                      this.handleChangeSelectorDropdown
                    }
                    //validateField={this.validateField}
                    submitEmploymentInformation={this.submitEmploymentInformation.bind(
                      this
                    )}
                    basicApplicationDetails={this.state.basicApplicationDetails}
                    oganisationReference={this.state.oganisationReference}
                    getEmploymentHistoryById={this.getEmploymentHistoryById.bind(
                      this
                    )}
                    handleEmploymentRadioChange={this.handleEmploymentRadioChange.bind(
                      this
                    )}
                    GetCPASMemberFiles={this.GetCPASMemberFiles.bind(this)}
                    isSubmitLoader={this.state.isSubmitLoader}
                    isDraftLoader={this.state.isDraftLoader}
                    cpasMemberid={this.state.cpasMemberid}
                    resetHandler={this.resetHandler}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Project Information */}
          <div className="bg-white border border-[#c9c9c9] mb-3">
            <div className="tab w-full border-t">
              <input
                className="absolute opacity-0 toggle-main"
                id="PR"
                type="checkbox"
                name="corporate-d"
                value="ProjectInfoSummary"
                checked={this.state.openSection === "ProjectInfoSummary"}
                onClick={() => this.openSection("ProjectInfoSummary")}
              />
              <label
                className="heading-part px-7 py-4 border-b border-[#c9c9c9] flex items-center justify-between relative w-auto leading-normal cursor-pointer"
                htmlFor="PR"
              >
                <span className="small-title font-bold theme-color pl-5">
                  Project Information
                </span>
              </label>

              <div className="committee-info-overflow tab-content overflow-hidden leading-normal px-0">
                <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-4 lg:pt-4">
                  <ProjectInfoSummary
                    openProjectCitedInReportModal={
                      this.state.openProjectCitedInReportModal
                    }
                    setOpenProjectCitedInReportModal={this.setOpenProjectCitedInReportModal.bind(
                      this
                    )}
                    projectInfoSummary={this.state.projectInfoSummary}
                    projectCiteWrittenObj={this.state.projectCiteWrittenObj}
                    handleChange={this.handleChange}
                    onFileChange={this.onFileChange.bind(this)}
                    handleAddRemoveDataList={this.handleAddRemoveDataList}
                    handleChangeSelectorDropdown={
                      this.handleChangeSelectorDropdown
                    }
                    projectInformation={this.state.projectInformation}
                    projectInformationdetail={
                      this.state.projectInformationdetail
                    }
                    deleteCpasProjectCitedInReport={this.deleteCpasProjectCitedInReport.bind(
                      this
                    )}
                    getProjectCitedInReport={this.getProjectCitedInReport.bind(
                      this
                    )}
                    isUploadDocumentary={this.state.isUploadDocumentary}
                    isEndorsement={this.state.isEndorsement}
                    projectAndPaymentInfoSummary={
                      this.state.projectAndPaymentInfoSummary
                    }
                    submitProjectSummaryInformation={this.submitProjectSummaryInformation.bind(
                      this
                    )}
                    GetCPASMemberFiles={this.GetCPASMemberFiles.bind(this)}
                    isSubmitLoader={this.state.isSubmitLoader}
                    isDraftLoader={this.state.isDraftLoader}
                    basicApplicationDetails={this.state.basicApplicationDetails}

                  />
                </div>
              </div>
            </div>
          </div>

          {/* CPAS Membership Task List */}

          <div className="bg-white border border-[#c9c9c9] mb-3">
            <div className="tab w-full border-t">
              <input
                className="absolute opacity-0 toggle-main"
                id="Membership"
                type="checkbox"
                name="corporate-d"
                value="Membership"
                checked={this.state.openSection === "Membership"}
                onClick={() => this.openSection("Membership")}
              />
              <label
                className="heading-part px-7 py-4 border-b border-[#c9c9c9] flex items-center justify-between relative w-auto leading-normal cursor-pointer"
                htmlFor="Membership"
              >
                <span className="small-title font-bold theme-color pl-5">
                  CPAS Membership Task List Process
                </span>

                {/* Right Side */}
                <div className="flex flex-col items-end">
                  <span className="small-title font-bold theme-color">
                    Status : {this.state.basicApplicationDetails.statusName}
                  </span>

                  {this.state.basicApplicationDetails.paymentStatus === "Pending" && (
                    <span style={{ color: "red", fontSize: "18px" }}>
                      Payment not accepted yet
                    </span>
                  )}
                  {this.state.basicApplicationDetails.statusId === 40 &&
                    this.state.basicApplicationDetails.paymentStatusForAppeal ===
                    "Pending" && (
                      <span style={{ color: "red", fontSize: "18px" }}>
                        Payment not accepted yet
                      </span>
                    )}

                  {this.state.basicApplicationDetails.statusId === 34 && (
                    <span style={{ color: "red", fontSize: "18px" }}>
                      Waiting for applicant to submit the PPT file
                    </span>
                  )}


                  {this.state.basicApplicationDetails.statusId === 36 && (
                    <span style={{ color: "red", fontSize: "18px" }}>
                      Please go to Assign Interview for the next step
                    </span>
                  )}
                </div>
              </label>

              <div className="committee-info-overflow tab-content overflow-hidden leading-normal px-0">
                <CPASMembershipTaskListProcess
                  DownloadCPASMultipleZipFiles={this.DownloadCPASMultipleZipFiles.bind(this)}
                  AcceptAndApproveCpasMember={this.AcceptAndApproveCpasMember.bind(this)}
                  interviewComment={this.state.interviewComment}
                  RejectCpasMember={this.RejectCpasMember.bind(this)}
                  RejectAppealCpasMember={this.RejectAppealCpasMember.bind(this)}

                  allInterviewDetailsList={this.state.allInterviewDetailsList}
                  pptFilepath={this.state.pptFilepath}
                  openProfappModal={this.state.openProfappModal}
                  openProModal={this.state.openProModal}
                  openEduModal={this.state.openEduModal}
                  setOpenEduModal={this.setOpenEduModal.bind(this)}
                  setOpenProModal={this.setOpenProModal.bind(this)}
                  setOpenProfappModal={this.setOpenProfappModal.bind(this)}
                  getEducationalInformation={this.getEducationalInformation.bind(this)}
                  getProfessionalQualifications={this.getProfessionalQualifications.bind(this)}
                  cpasMemberid={this.state.cpasMemberid}
                  basicApplicationDetails={this.state.basicApplicationDetails}
                  applicationTierList={this.state.applicationTierList}
                  mrMrsList={this.state.mrMrsList}
                  handleChange={this.handleChange.bind(this)}
                  onFileChange={this.onFileChange}
                  handleChangeSelectorDropdown={this.handleChangeSelectorDropdown}
                  updateSecretariatAndPreAssessmentStatus={this.UpdateSecretariatAndPreAssessmentStatus.bind(this)}
                  secretariatAndPreAssessmentStatusId={
                    this.state.secretariatAndPreAssessmentStatusId
                  }
                  paymentStatus={
                    this.state.basicApplicationDetails.paymentStatus
                  }
                  setSendClarificationsFlag={this.setSendClarificationsFlag.bind(
                    this
                  )}
                  openScoringSheet={this.openScoringSheet.bind(this)}
                  rejectSecretariatStage={this.rejectSecretariatStage.bind(this)}
                  rejectSPreAssessmentStage={this.rejectSPreAssessmentStage.bind(this)}
                  rejectSecretariatReview={this.rejectSecretariatReview.bind(this)}
                  sendForPreAssessmentSecretariatReview={this.sendForPreAssessmentSecretariatReview.bind(this)}
                  statusId={this.state.statusId}
                  GetCPASMemberFiles={this.GetCPASMemberFiles.bind(this)}
                  openScoringSheetResults={this.openScoringSheetResults}
                  isApproveLoading={this.state.isApproveLoading}
                  isAppealLoading={this.state.isAppealLoading}
                  isRejectappealLoading={this.state.isRejectappealLoading}
                  isRejectLoading={this.state.isRejectLoading}

                  interviewText={this.state.interviewText}
                />
              </div>
              <SendClarifications
                //validState={this.state.validState}
                //validateField={this.validateField.bind(this)}
                clarificationModal={this.state.setSendClarifications}
                clarification={this.state.clarification}
                isLoading={this.state.isLoading}
                setOpenModal={() =>
                  this.setState({ setSendClarifications: false })
                }
                onTinyEceEditorChange={(data) =>
                  this.handleChangeClarificationDetails(data)
                }
                // isValidateAllFields1={this.state.isValidateAllFields1}
                // onClose={(e) => {e.stopPropagation();
                //   this.setState({ setSendClarifications: false });
                // }}
                saveClarificationDetails={this.saveClarificationDetails.bind(
                  this
                )}
              />
            </div>
          </div>

          {/* Cpd Submission */}
          <div className="bg-white border border-[#c9c9c9] mb-3">
            <div className="tab w-full border-t">
              <input
                className="absolute opacity-0 toggle-main"
                id="CPD"
                type="checkbox"
                name="corporate-d"
                value="CpdSubmission"
                checked={this.state.openSection === "CpdSubmission"}
                onClick={() => this.openSection("CpdSubmission")}
              />
              <label
                className="heading-part px-7 py-4 border-b border-[#c9c9c9] flex items-center justify-between relative w-auto leading-normal cursor-pointer"
                htmlFor="CPD"
              >
                <span className="small-title font-bold theme-color pl-5">
                  CPD Submission
                </span>
              </label>

              <div className="committee-info-overflow tab-content overflow-hidden leading-normal px-0">
                <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-4 lg:pt-4">
                  <CpdSubmission
                    cpdSubmissionDetails={this.state.cpdSubmissionDetails}
                    handleChange={this.handleChange}
                    cpdSubmissionDetailsObj={this.state.cpdSubmissionDetailsObj}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-12 col-span-12">
            <div className="bottom-btn-sec flex gap-4">
              <button
                className="btn btn-reject"
                onClick={(event) => this.GetCPASMemberFiles('Upload_PPT', this.state.pptFilepath, event)}
                disabled={!this.state.pptFilepath}

              >
                View PPT
              </button>

              <button
                className="btn btn-primary-caps"
                style={{ backgroundColor: '#E59B41', color: '#FFFFFF' }}
                onClick={(event) => this.DownloadCPASMultipleZipFiles('InterviewSheetFile')}
                disabled={!(this.state.assessorInterviewResultsPath?.length > 2)}
              >
                View Interview Result
              </button>

              <button
                className="btn btn-sen-pre-assessment"
                style={{
                  backgroundColor: '#10396B',
                  color: '#FFFFFF',
                  opacity: [1, 2, 29, 30, 31, 32, 33].includes(this.state.statusId) ? 0.5 : 1, // Dims when disabled
                  cursor: [1, 2, 29, 30, 31, 32, 33].includes(this.state.statusId) ? 'not-allowed' : 'pointer'
                }}
                onClick={(event) => this.openScoringSheetResults(true)}
                disabled={[2, 29, 30, 31, 32, 33, 1].includes(this.state.statusId)}
              >
                Pre-Assessment Result
              </button>

            </div>
          </div>
        </div>
      </>
    );
  }
}
